import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatAutocompleteSelectedEvent,
  MatBottomSheetRef,
} from "@angular/material";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { Mid } from "src/app/constants/mids";

export interface CpsFilterPayload {
  defined: string[];
  values: string;
}

@Component({
  selector: "app-cps-multiple-selector",
  templateUrl: "./cps-multiple-selector.component.html",
  styleUrls: ["./cps-multiple-selector.component.scss"],
})
export class CpsMultipleSelectorComponent implements OnInit {
  public paymentMids: Mid[] = Object.values(Mid) as Mid[];

  public defined: string[] = [];

  public valuesControl = new FormControl("");

  public selection: any[] = [];

  public filteredOptions: Observable<any[]>;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private self: MatBottomSheetRef<CpsMultipleSelectorComponent>
  ) {
    const sel = this.data.selected as CpsFilterPayload | string[] | undefined;
    if (sel) {
      if (Array.isArray(sel)) {
        this.defined = sel.map(String);
      } else if (sel && typeof sel === "object") {
        this.defined = Array.isArray(sel.defined)
          ? sel.defined.map(String)
          : [];
        this.valuesControl.setValue(
          typeof sel.values === "string" ? sel.values : ""
        );
      }
    }

    this.selection = this.data.selection || [];
  }

  ngOnInit() {
    this.filteredOptions = this.valuesControl.valueChanges.pipe(
      startWith(this.valuesControl.value || ""),
      map((value) => {
        const filterVal =
          typeof value === "string" ? value : String(value != null ? value : "");
        return this.selection.filter((option) =>
          this.lowerCase(option.label).includes(this.lowerCase(filterVal))
        );
      })
    );

    this.self.backdropClick().subscribe(() => {
      this.self.dismiss(this.getResult());
    });
  }

  public lowerCase(value: any) {
    if (value === null || value === undefined) {
      return "";
    }
    return (value + "").toLowerCase();
  }

  public clearFilter(): void {
    this.defined = [];
    this.valuesControl.setValue("");
  }

  public onEnter(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  public addDefined(mid: Mid): void {
    const v = String(mid);
    if (!this.defined.includes(v)) {
      this.defined.push(v);
    } else {
      this.defined = this.defined.filter((m) => m !== v);
    }
  }


  public onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const val = event.option.value;
    this.valuesControl.setValue(val != null ? String(val) : "");
  }

  public deleteItem(index: number) {
    this.defined.splice(index, 1);
  }

  public getResult(): CpsFilterPayload {
    const raw = this.valuesControl.value;
    const values =
      typeof raw === "string" ? raw : raw != null ? String(raw) : "";
    return {
      defined: [...this.defined],
      values,
    };
  }
}
